import { ReactNode, useId } from 'react';

import {
  FormGroup,
  FormHelpText,
  FormTextarea,
  FormTextareaProps,
} from '@spotify-internal/encore-web';

export type FormTextareaFieldProps = Omit<FormTextareaProps, 'id' | 'error'> & {
  label: string;
  helperText?: ReactNode;
  error?: string | null;
  'data-testid'?: string;
};

export const FormTextareaField = ({
  label,
  helperText,
  error,
  name,
  size = 'small',
  'data-testid': dataTestId = name,
  ...textareaProps
}: FormTextareaFieldProps) => {
  const textareaId = useId();
  const helpTextId = useId();
  const helpText = error ?? helperText;

  return (
    <FormGroup label={label} labelFor={textareaId} data-testid={dataTestId}>
      <FormTextarea
        {...textareaProps}
        id={textareaId}
        name={name}
        size={size}
        error={Boolean(error)}
        aria-describedby={helpText ? helpTextId : undefined}
      />
      {helpText && (
        <FormHelpText id={helpTextId} error={Boolean(error)}>
          {helpText}
        </FormHelpText>
      )}
    </FormGroup>
  );
};
